module.exports = __webpack_public_path__ + "static/media/social4.18363d1d.png";